import API from '../../../../../../lib/api'
import { ORDER_DETAILS_API_URL } from '../../../../DeliveryOrdersPicking/constants/pagination'

export const isPickingDeliveryDetailPath = (pathname = '') =>
  String(pathname).includes('/picking-delivery-orders/')

/**
 * Resolves a delivery order reference to its picking order_details row so a
 * direct load / refresh of the detail page (which has no router state) can tell
 * whether the order is DSP and obtain the numeric orderId used for packlists.
 *
 * Returns the first matching row, or null when the reference is empty or not
 * found in picking-service. Source (DSP/DBP) comes from the API response.
 *
 * @param {string} referenceNumber
 */
export const resolvePickingOrderByReference = async (referenceNumber) => {
  if (!referenceNumber) {
    return null
  }

  try {
    const api = new API({ url: ORDER_DETAILS_API_URL })
    const response = await api.get({ referenceNumber, pageSize: 1 })
    const rows = response?.orderDetails || []

    return rows.length ? rows[0] : null
  } catch {
    return null
  }
}

export default resolvePickingOrderByReference
